import { Five } from "./Chart.config";
import { redPana } from "../JodiCharts/Chart.config";
import { fa_time } from "../../Helpers/getWeekDays";
import CommonTable from "../../Helpers/CommonTable";

const ShreeDevi = ({ chartData }) => {
  const renderDate = (val) => fa_time(val);

  return (
    <CommonTable
      staticData={Five}
      chartData={chartData}
      redJodi={redPana.map((j) => parseInt(j))}
      renderDate={renderDate}
    />
  );
};

export default ShreeDevi;
